import { PesquisaProtocolos } from '../_models/PesquisaProtocolos';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';
import { DocumentoPreEditado } from '../_models/DocumentoPreEditado';

@Injectable({
    providedIn: 'root'
})

export class DocumentoPreEditadoService {

    constructor(private http: HttpClient,
        private datePipe: DatePipe,
        private alertService: AlertService) { }

    CriarDocumentoPreEditado(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/ProtocoloNotaFiscal`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

         return this.http.post<any>(apiURL, formDataUpload, options);
    }

    VerificaProtocoloDuplicidade(protocolo: DocumentoPreEditado): Observable<any> {
        //Mt 8.5-13
        const dataEmissaoNfe = this.datePipe.transform(protocolo.dataEmissaoNf, 'yyyy-MM-dd');
        const dataVencimentoNfe = this.datePipe.transform(protocolo.dataVencimentoNf, 'yyyy-MM-dd');

        const apiURL = `${environment.apiUrl}/api/ProtocoloNotaFiscal/duplicidade?valor=`+
                        `${protocolo.valor}&idProtocolo=${protocolo.idProtocolo}&fornecedor=`+
                        `${protocolo.cnpjfornecedor}&divisao=${protocolo.divisao}&tipoDocumento=${protocolo.idTipoDocumento}`+
                        `&dtEmissao=${dataEmissaoNfe}&dtVencimento=${dataVencimentoNfe}`;
        return this.http.get<any>(apiURL);
    }

    AtualizarDocumentoPreEditado(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/ProtocoloNotaFiscal/update`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
            headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }

    CancelarDocumentoPreEditado(protocolo: DocumentoPreEditado): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/ProtocoloNotaFiscal/delete`;
        return this.http.post<any>(apiURL, protocolo);
    }

    obterProtocolos(): Observable<any> {
        return this.http.get<DocumentoPreEditado[]>(`${environment.apiUrl}/api/ProtocoloNotaFiscal`);
    }

    public obterUltimosProtocoloPendentesRpa() {
        return this.http.get<any>(`${environment.apiUrl}/api/ProtocoloNotaFiscal/protocolos-pendentes-aprovacao-comercial`);
    }

    obterProtocolosPesquisa(pesquisaProtocolos: PesquisaProtocolos): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/ProtocoloNotaFiscal/protocolosPesquisa`;
        return this.http.post<any>(apiURL, pesquisaProtocolos);
    }

    sanitizarDiretorioUpload(): Observable<any> {
        return this.http.get<DocumentoPreEditado[]>(`${environment.apiUrl}/api/ProtocoloNotaFiscal/sanitizarDiretorioUpload`);
    }

    obterProtocolo(id: string): Observable<any> {
        return this.http.get<DocumentoPreEditado>(`${environment.apiUrl}/api/ProtocoloNotaFiscal/${id}`);
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um problema ao verificar aempresa MRV. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    // FundoFixo
    CriarDocumentoFundoFixo(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/FundoFixo`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }

    AtualizarDocumentoFundoFixo(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/FundoFixo/update`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
            headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }

    CancelarDocumentoFundoFixo(protocolo: DocumentoPreEditado): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/FundoFixo/delete`;
        return this.http.post<any>(apiURL, protocolo);
    }

    // Adiantamento
    CriarDocumentoAdiantamento(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/Adiantamento`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }

    atualizarDocumentoAprovado(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DocumentoAprovado/atualizarDocumentoPreEditado`;
        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
                headers: headers
        };

         return this.http.post<any>(apiURL, formDataUpload, options);
    }
}
